// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.draggable[data-v-dd5132a4]{\r\n\tpadding:0;\r\n\tmargin:0;\r\n\tborder: 1px var(--main-color) dashed;\r\n\tcursor:move;\r\n\tposition: absolute;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
